module.exports = "<div class=\"wysiwyg-editor-container\">\n  <textarea \n    id=\"{{$ctrl.editorId}}\"\n    ng-model=\"$ctrl.content\"\n    ng-model-options=\"{ debounce: 300 }\"\n    ng-change=\"$ctrl.onContentChange()\"\n    style=\"min-height: {{$ctrl.height || '300px'}};\">\n  </textarea>\n</div>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/wysiwyg-editor/wysiwyg-editor.html
// module id = 581
// module chunks = 0